export default {"src":"/_next/static/media/arrow-left.6b674352.svg","height":288,"width":288};